var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 13.25C14.7949 13.25 16.25 11.7949 16.25 10C16.25 8.20507 14.7949 6.75 13 6.75C11.2051 6.75 9.75 8.20507 9.75 10C9.75 11.7949 11.2051 13.25 13 13.25ZM17.25 10C17.25 12.3472 15.3472 14.25 13 14.25C10.6528 14.25 8.75 12.3472 8.75 10C8.75 7.65279 10.6528 5.75 13 5.75C15.3472 5.75 17.25 7.65279 17.25 10Z",
    fill: "#2D2943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2975 22.084L20.2768 21.9082C20.049 19.9755 18.4863 18.2355 16.1471 17.3757C15.1953 17.0258 14.1285 16.8289 12.9999 16.8289C10.774 16.8289 8.79838 17.594 7.46652 18.7755C6.47578 19.6545 5.85989 20.7445 5.72296 21.9082L5.70227 22.084L4.91614 21.9821L4.93547 21.811C5.10095 20.3466 5.86404 19.0519 6.98013 18.0618C8.47086 16.7393 10.6249 15.925 12.9999 15.925C14.2087 15.925 15.3578 16.1358 16.3906 16.5154C18.8884 17.4335 20.7902 19.3836 21.0643 21.811L21.0836 21.9821L20.2975 22.084Z",
    fill: "#2D2943"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 24.275C19.227 24.275 24.275 19.227 24.275 13C24.275 6.77299 19.227 1.725 13 1.725C6.77299 1.725 1.725 6.77299 1.725 13C1.725 19.227 6.77299 24.275 13 24.275ZM25.125 13C25.125 19.6965 19.6965 25.125 13 25.125C6.30355 25.125 0.875 19.6965 0.875 13C0.875 6.30355 6.30355 0.875 13 0.875C19.6965 0.875 25.125 6.30355 25.125 13Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileHover);
export default __webpack_public_path__ + "static/media/profile-hover.60facced.svg";
export { ForwardRef as ReactComponent };